import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '@environments/environment';
import { apiEndPoints, apiMethods } from '@constants/index';

// Base API service. This allows us to centralize all http operations so we can
// have a consistent experience as well as handle errors in a central location.
@Injectable()
export class ApiService {
  private apiMethods = apiMethods;
  constructor(private http: HttpClient) { }

  invoke(params): Observable<any> {
    let requestURL;
    if (params) {
      const method = params.method.toLowerCase();
      const { path, body, query } = params;
      const url = `${environment.apiUrl}${apiEndPoints.api}${apiEndPoints.version1}`;
      if (method === 'get') {
        requestURL = `${url}${path}`;
      } else {
        requestURL = `${url}${path}/`;
      }
      let request;
      let requestParams = new HttpParams();

      /**
       * CUSTOM REQUEST QUERY (?key=value)
       */
      if (query) {
        for (const key in query) {
          if (query.hasOwnProperty(key)) {
            requestParams = requestParams.append(key, query[key]);
          }
        }
      }

      const requestOptions = {
        params: requestParams,
      };

      /**
       * HANDLE GET, POST etc. REQUESTS
       */
      if (method === this.apiMethods.get) {
        request = this.http[method](requestURL, requestOptions);
      } else if (method === this.apiMethods.post || method === this.apiMethods.put || method === this.apiMethods.patch) {
        request = this.http[method](
          requestURL,
          body,
          requestOptions,
        );
      } else if (method === this.apiMethods.delete) {
        request = this.http.request(method, requestURL, {
          ...requestOptions,
          body,
        });
      }

      /**
       * RETURN API REQUEST
       */
      return request;
    }
  }
}
